// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  width: 100%;
  height: 100vh;
  background-color: #f4ffdf;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main .content {
  text-align: center;
  width: 50%;
  margin: auto;
}
.main .content img {
  width: 51%;
}
.main .content .code {
  font-size: 60px;
  margin-bottom: 10px;
}
.main .content .text {
  font-size: 25px;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/main/errorsPages/404/error-404.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AACN;AACM;EACI,UAAA;AACV;AAEM;EACQ,eAAA;EACA,mBAAA;AAAd;AAGM;EACI,eAAA;EACA,gBAAA;AADV","sourcesContent":[".main {\r\n  width: 100%;\r\n  height: 100vh;\r\n  background-color: #f4ffdf;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  .content {\r\n      text-align: center;\r\n      width: 50%;\r\n      margin: auto;\r\n\r\n      img {\r\n          width: 51%;\r\n      }\r\n\r\n      .code {\r\n              font-size: 60px;\r\n              margin-bottom: 10px;\r\n      }\r\n  \r\n      .text {\r\n          font-size: 25px;\r\n          margin-top: 10px;\r\n      }\r\n             \r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
